// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { counterWidgetStyles } from "@sc/App/Widgets/CounterWidget/CounterWidget";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

counterWidgetStyles.wrapper = {
    css: css`
        width: 100%;
        display: flex;
        flex-direction: column;
    `,
};

counterWidgetStyles.title = {
    size: 24,
    lineHeight: "32px",
    weight: "bold",
    css: css`
        margin-bottom: 16px;
        text-align: center;
        width: 100%;
    `,
};

counterWidgetStyles.heading = {
    size: 48,
    lineHeight: "58px",
    weight: "bold",
    css: css`
        margin-bottom: 12px;
        text-align: center;
        width: 100%;
    `,
};

counterWidgetStyles.subHeading = {
    size: 18,
    lineHeight: "24px",
    weight: "bold",
    css: css`
        text-align: center;
        width: 100%;
    `,
};

counterWidgetStyles.counter = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        padding-top: 20px;
        padding-bottom: 20px;
        &:not(:last-child) {
            padding-right: 20px;
            border-right: 1px solid ${color("common.border")};
        }


        ${({ width }: any) => {
            if (width === "100%") {
                return "flex-basis: 100%;";
            }
            if (width === "50%") {
                return css`
                    flex-basis: calc(50% - 10px);
                `;
                // eslint-disable-next-line no-else-return
            } else if (width === "33%") {
                return css`
                    flex-basis: calc((100% - 40px) / 3);
                `;
            } else {
                return css`
                    flex-basis: calc(25% - 15px);
                `;
            }
        }}

        ${xScreen("lte", "md")} {
            flex-basis: calc(50% - 10px);
            &:nth-child(even) {
                padding-right: 0;
                border-right: none;
            }
        }
        ${xScreen("lte", 767)} {
            flex-basis: 100%;
            && {
                padding-right: 0;
                padding-left: 0;
                border-right: none;
            }
        }
    `,
};

counterWidgetStyles.container = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
    `,
};
